export const ORDER_ITEM_SUPPLIER_GO_BUTTON_ACTION = 'ORDER_ITEM_SUPPLIER_GO_BUTTON_ACTION'
export const ORDER_ITEM_SUPPLIER_GO_BUTTON_SUCCESS = 'ORDER_ITEM_SUPPLIER_GO_BUTTON_SUCCESS'

export const ORDER_ITEM_SUPPLIER_API_ERROR_ACTION = 'ORDER_ITEM_SUPPLIER_API_ERROR_ACTION'